import { createContext } from 'react';

import User from '../view-model/users/User';

export type UserContextType = User;

const UserContext = createContext<UserContextType>(null as any);

UserContext.displayName = 'UserContext';

export default UserContext;
